module.exports = __webpack_public_path__ + "assets/img/loading-monkey.704a6d17ea93acac311ab2837bf542b0.svg";